import {
  START_LOADING,
  STOP_LOADING,
  START_COMPONENT_LOADING,
  STOP_COMPONENT_LOADING,
} from "../../constants/actionTypes";

export const setPageLoading = () => {
  return {
    type: START_LOADING,
    payload: true,
  };
};

export const clearPageLoading = () => {
  return {
    type: STOP_LOADING,
    payload: false,
  };
};

export const setComponentLoading = (componentName) => {
  return {
    type: START_COMPONENT_LOADING,
    payload: componentName,
  };
};

export const clearComponentLoading = (componentName) => {
  return {
    type: STOP_COMPONENT_LOADING,
    payload: componentName,
  };
};
